"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const boxburst = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 43 60",
    "aria-labelledby": (title ? "title-boxburst" : '') + (description ? " desc-boxburst" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-boxburst"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-boxburst"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Artboard",
    transform: "translate(-56.000000, -130.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Icon",
    transform: "translate(57.000000, 131.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-4",
    transform: "translate(1.505432, 16.089552)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.5783238,42.5706984 C22.9231996,42.9272886 22.1572827,42.952119 21.4838495,42.6385995 L4.11467296,34.5638003 C3.1952951,34.1370737 2.59867248,33.1536281 2.59867248,32.0650397 L2.59867248,13.6258163 C2.59867248,12.5708178 3.1597678,11.6113446 4.03737688,11.1650803 L20.3219149,2.88657784 C20.9459647,2.5697789 21.6624952,2.54815281 22.3016918,2.82682487 L38.4316377,9.85594703 C39.3782665,10.2679026 39.9993548,11.2660433 40,12.376436 L40,31.9455338 C39.9994958,32.9740066 39.465733,33.91395 38.6211377,34.3736772 L23.5783238,42.5706984 Z",
    id: "Path",
    fillOpacity: "0.25",
    fill: "#FFCCD8"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "streamline-icon-shipment-in-transit@140x140",
    stroke: "#F26B1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.8"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "19.9473747",
    y1: "17.4114712",
    x2: "19.9448813",
    y2: "17.4114712",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9796513,39.9383411 C20.3245271,40.2949313 19.5586102,40.3197617 18.885177,40.0062422 L1.51600048,31.931443 C0.596622612,31.5047164 0,30.5212708 0,29.4326825 L0,10.993459 C0,9.93846055 0.561095315,8.97898733 1.4387044,8.532723 L17.7232424,0.254220546 C18.3472922,-0.0625783907 19.0638227,-0.0842044781 19.7030193,0.194467576 L35.8329652,7.22358974 C36.779594,7.63554529 37.4006823,8.63368598 37.4013275,9.74407868 L37.4013275,29.3131765 C37.4008233,30.3416493 36.8670606,31.2815927 36.0224652,31.7413199 L20.9796513,39.9383411 Z",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "19.9473747",
    y1: "17.4114712",
    x2: "36.9325642",
    y2: "8.16062496",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    id: "Path",
    points: "0.443829087 9.44531382 19.9448813 17.4114712 19.9448813 40.2180936"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "28.0036206",
    y1: "13.0223439",
    x2: "9.5921938",
    y2: "4.38803969",
    id: "Path"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-17",
    transform: "translate(20.500000, 6.500000) rotate(270.000000) translate(-20.500000, -6.500000) translate(14.000000, -14.000000)",
    stroke: "#F26B1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.8"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "0",
    y1: "5",
    x2: "6",
    y2: "0",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "0",
    y1: "36",
    x2: "6",
    y2: "41",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "5",
    y1: "20.5",
    x2: "13",
    y2: "20.5",
    id: "Path"
  }))))));
};
var _default = exports.default = boxburst;